import { jsx as p } from "react/jsx-runtime";
import { createContext as a, useContext as m } from "react";
import { Information as f } from "./pictograms/Information.js";
import { InternalDrains as n } from "./pictograms/InternalDrains.js";
import { AccountInCreditPositiveBalance as s } from "./pictograms/AccountInCreditPositiveBalance.js";
import { AccountInDebtNegativeBalance as c } from "./pictograms/AccountInDebtNegativeBalance.js";
import { AddYourCar as l } from "./pictograms/AddYourCar.js";
import { Archive as g } from "./pictograms/Archive.js";
import { AssistanceDog as u } from "./pictograms/AssistanceDog.js";
import { Awards as d } from "./pictograms/Awards.js";
import { Battery13 as h } from "./pictograms/Battery13.js";
import { Battery23 as y } from "./pictograms/Battery23.js";
import { Battery33 as b } from "./pictograms/Battery33.js";
import { BatteryEmpty as C } from "./pictograms/BatteryEmpty.js";
import { Bill as P } from "./pictograms/Bill.js";
import { Bin as v } from "./pictograms/Bin.js";
import { BoilerEngineer as T } from "./pictograms/BoilerEngineer.js";
import { BoilerHeating as S } from "./pictograms/BoilerHeating.js";
import { BoilerReplacement as E } from "./pictograms/BoilerReplacement.js";
import { BoilerService as k } from "./pictograms/BoilerService.js";
import { BoilerWorking as B } from "./pictograms/BoilerWorking.js";
import { Boiler as M } from "./pictograms/Boiler.js";
import { Bus as w } from "./pictograms/Bus.js";
import { Calendar as x } from "./pictograms/Calendar.js";
import { Car as A } from "./pictograms/Car.js";
import { ChargerChademo as L } from "./pictograms/ChargerChademo.js";
import { ChargerCssCombo as D } from "./pictograms/ChargerCssCombo.js";
import { ChargerType1 as U } from "./pictograms/ChargerType1.js";
import { ChargerType2 as H } from "./pictograms/ChargerType2.js";
import { Cloakroom as I } from "./pictograms/Cloakroom.js";
import { Clock as F } from "./pictograms/Clock.js";
import { Comedy as G } from "./pictograms/Comedy.js";
import { Competition as W } from "./pictograms/Competition.js";
import { Confirmation as O } from "./pictograms/Confirmation.js";
import { ContactUs as R } from "./pictograms/ContactUs.js";
import { CreatePaymentSchedule as N } from "./pictograms/CreatePaymentSchedule.js";
import { CreditCard as Y } from "./pictograms/CreditCard.js";
import { Cursor as j } from "./pictograms/Cursor.js";
import { CustomerStar as q } from "./pictograms/CustomerStar.js";
import { Customer as K } from "./pictograms/Customer.js";
import { DisbaledToilet as Q } from "./pictograms/DisbaledToilet.js";
import { DownloadApp as z } from "./pictograms/DownloadApp.js";
import { Drink as J } from "./pictograms/Drink.js";
import { EcoHome as V } from "./pictograms/EcoHome.js";
import { Edit as X } from "./pictograms/Edit.js";
import { ElectricCarEv as Z } from "./pictograms/ElectricCarEv.js";
import { Electric as _ } from "./pictograms/Electric.js";
import { Emergency as $ } from "./pictograms/Emergency.js";
import { EnergyAdvice as rr } from "./pictograms/EnergyAdvice.js";
import { EnergyExperts as or } from "./pictograms/EnergyExperts.js";
import { EstimatedCharge2 as mr } from "./pictograms/EstimatedCharge2.js";
import { EstimatedCharge as tr } from "./pictograms/EstimatedCharge.js";
import { EstimatedRange as er } from "./pictograms/EstimatedRange.js";
import { EvCharger as ir } from "./pictograms/EvCharger.js";
import { ExitFees as pr } from "./pictograms/ExitFees.js";
import { ExternalDrains as ar } from "./pictograms/ExternalDrains.js";
import { Filter as fr } from "./pictograms/Filter.js";
import { FinalStatement as nr } from "./pictograms/FinalStatement.js";
import { FlagIssue as sr } from "./pictograms/FlagIssue.js";
import { Flats as cr } from "./pictograms/Flats.js";
import { Food as lr } from "./pictograms/Food.js";
import { Gas as gr } from "./pictograms/Gas.js";
import { GetInTouch as ur } from "./pictograms/GetInTouch.js";
import { Global as dr } from "./pictograms/Global.js";
import { GreenerEnergy as hr } from "./pictograms/GreenerEnergy.js";
import { GuitarMusic as yr } from "./pictograms/GuitarMusic.js";
import { Heart as br } from "./pictograms/Heart.js";
import { HeatPump as Cr } from "./pictograms/HeatPump.js";
import { Help as Pr } from "./pictograms/Help.js";
import { HistoryPayment as vr } from "./pictograms/HistoryPayment.js";
import { HomeMove as Tr } from "./pictograms/HomeMove.js";
import { Home as Sr } from "./pictograms/Home.js";
import { Lasers as Er } from "./pictograms/Lasers.js";
import { Leaf as kr } from "./pictograms/Leaf.js";
import { Letter as Br } from "./pictograms/Letter.js";
import { Lifts as Mr } from "./pictograms/Lifts.js";
import { Lightbulb as wr } from "./pictograms/Lightbulb.js";
import { List as xr } from "./pictograms/List.js";
import { LoadingAndFlexibility as Ar } from "./pictograms/LoadingAndFlexibility.js";
import { Location as Lr } from "./pictograms/Location.js";
import { Lpg as Dr } from "./pictograms/Lpg.js";
import { Magnify as Ur } from "./pictograms/Magnify.js";
import { ManageMyAccount as Hr } from "./pictograms/ManageMyAccount.js";
import { Map as Ir } from "./pictograms/Map.js";
import { MensToilet as Fr } from "./pictograms/MensToilet.js";
import { Merch as Gr } from "./pictograms/Merch.js";
import { MeterReading as Wr } from "./pictograms/MeterReading.js";
import { Mobile as Or } from "./pictograms/Mobile.js";
import { Money as Rr } from "./pictograms/Money.js";
import { Msg as Nr } from "./pictograms/Msg.js";
import { Music as Yr } from "./pictograms/Music.js";
import { MyPaymentCards as jr } from "./pictograms/MyPaymentCards.js";
import { Navigation as qr } from "./pictograms/Navigation.js";
import { Notification as Kr } from "./pictograms/Notification.js";
import { NumberOfSeats as Qr } from "./pictograms/NumberOfSeats.js";
import { Oil as zr } from "./pictograms/Oil.js";
import { OpenLetter as Jr } from "./pictograms/OpenLetter.js";
import { Padlock as Vr } from "./pictograms/Padlock.js";
import { Parking as Xr } from "./pictograms/Parking.js";
import { PayAsYouGo as Zr } from "./pictograms/PayAsYouGo.js";
import { PayByBankTransfer as _r } from "./pictograms/PayByBankTransfer.js";
import { PaygDrive as $r } from "./pictograms/PaygDrive.js";
import { PaymentSchedule as ro } from "./pictograms/PaymentSchedule.js";
import { PingDriver as oo } from "./pictograms/PingDriver.js";
import { Placeholder as mo } from "./pictograms/Placeholder.js";
import { Planet as to } from "./pictograms/Planet.js";
import { Plug as eo } from "./pictograms/Plug.js";
import { Plumbing as io } from "./pictograms/Plumbing.js";
import { PowerMove as po } from "./pictograms/PowerMove.js";
import { PriceCut as ao } from "./pictograms/PriceCut.js";
import { Price as fo } from "./pictograms/Price.js";
import { Queue as no } from "./pictograms/Queue.js";
import { RealCharge2 as so } from "./pictograms/RealCharge2.js";
import { RealCharge as co } from "./pictograms/RealCharge.js";
import { ScheduledTopUps as lo } from "./pictograms/ScheduledTopUps.js";
import { Seats as go } from "./pictograms/Seats.js";
import { SecurityDog as uo } from "./pictograms/SecurityDog.js";
import { SemiDetached as ho } from "./pictograms/SemiDetached.js";
import { SmartHome as yo } from "./pictograms/SmartHome.js";
import { SmartMeter as bo } from "./pictograms/SmartMeter.js";
import { SmartThermostatA as Co } from "./pictograms/SmartThermostatA.js";
import { SmartThermostatB as Po } from "./pictograms/SmartThermostatB.js";
import { Smoke as vo } from "./pictograms/Smoke.js";
import { SolarPanel as To } from "./pictograms/SolarPanel.js";
import { SpecialEffects as So } from "./pictograms/SpecialEffects.js";
import { Sport as Eo } from "./pictograms/Sport.js";
import { Star as ko } from "./pictograms/Star.js";
import { StoreLocator as Bo } from "./pictograms/StoreLocator.js";
import { StrobeLights2 as Mo } from "./pictograms/StrobeLights2.js";
import { StrobeLights as wo } from "./pictograms/StrobeLights.js";
import { Sun as xo } from "./pictograms/Sun.js";
import { TapsAndToilets as Ao } from "./pictograms/TapsAndToilets.js";
import { Terraced as Lo } from "./pictograms/Terraced.js";
import { TheGrid as Do } from "./pictograms/TheGrid.js";
import { ThumbsDown as Uo } from "./pictograms/ThumbsDown.js";
import { ThumbsUp as Ho } from "./pictograms/ThumbsUp.js";
import { Ticket as Io } from "./pictograms/Ticket.js";
import { TimeRunningOut as Fo } from "./pictograms/TimeRunningOut.js";
import { Toilet as Go } from "./pictograms/Toilet.js";
import { TopUpInPaypointShop as Wo } from "./pictograms/TopUpInPaypointShop.js";
import { TopUpInStore as Oo } from "./pictograms/TopUpInStore.js";
import { TopUpCardOrKey as Ro } from "./pictograms/TopUpCardOrKey.js";
import { TopUpOnline as No } from "./pictograms/TopUpOnline.js";
import { TopUp as Yo } from "./pictograms/TopUp.js";
import { Torch as jo } from "./pictograms/Torch.js";
import { Train as qo } from "./pictograms/Train.js";
import { Trees as Ko } from "./pictograms/Trees.js";
import { Turbine as Qo } from "./pictograms/Turbine.js";
import { UnavailableCharger as zo } from "./pictograms/UnavailableCharger.js";
import { Underground as Jo } from "./pictograms/Underground.js";
import { Usage as Vo } from "./pictograms/Usage.js";
import { Wallet as Xo } from "./pictograms/Wallet.js";
import { WarmHome as Zo } from "./pictograms/WarmHome.js";
import { WaterSupplyPipe as _o } from "./pictograms/WaterSupplyPipe.js";
import { WindEnergy as $o } from "./pictograms/WindEnergy.js";
import { WomensToilet as rm } from "./pictograms/WomensToilet.js";
import { Wrench as om } from "./pictograms/Wrench.js";
const t = {
  information: f,
  "internal-drains": n,
  "account-in-credit-positive-balance": s,
  "account-in-debt-negative-balance": c,
  "add-your-car": l,
  archive: g,
  "assistance-dog": u,
  awards: d,
  battery13: h,
  battery23: y,
  battery33: b,
  "battery-empty": C,
  bill: P,
  bin: v,
  "boiler-engineer": T,
  "boiler-heating": S,
  "boiler-replacement": E,
  "boiler-service": k,
  "boiler-working": B,
  boiler: M,
  bus: w,
  calendar: x,
  car: A,
  "charger-chademo": L,
  "charger-css-combo": D,
  "charger-type1": U,
  "charger-type2": H,
  cloakroom: I,
  clock: F,
  comedy: G,
  competition: W,
  confirmation: O,
  "contact-us": R,
  "create-payment-schedule": N,
  "credit-card": Y,
  cursor: j,
  "customer-star": q,
  customer: K,
  "disbaled-toilet": Q,
  "download-app": z,
  drink: J,
  "eco-home": V,
  edit: X,
  "electric-car-ev": Z,
  electric: _,
  emergency: $,
  "energy-advice": rr,
  "energy-experts": or,
  "estimated-charge2": mr,
  "estimated-charge": tr,
  "estimated-range": er,
  "ev-charger": ir,
  "exit-fees": pr,
  "external-drains": ar,
  filter: fr,
  "final-statement": nr,
  "flag-issue": sr,
  flats: cr,
  food: lr,
  gas: gr,
  "get-in-touch": ur,
  global: dr,
  "greener-energy": hr,
  "guitar-music": yr,
  heart: br,
  "heat-pump": Cr,
  help: Pr,
  "history-payment": vr,
  "home-move": Tr,
  home: Sr,
  lasers: Er,
  leaf: kr,
  letter: Br,
  lifts: Mr,
  lightbulb: wr,
  list: xr,
  "loading-and-flexibility": Ar,
  location: Lr,
  lpg: Dr,
  magnify: Ur,
  "manage-my-account": Hr,
  map: Ir,
  "mens-toilet": Fr,
  merch: Gr,
  "meter-reading": Wr,
  mobile: Or,
  money: Rr,
  msg: Nr,
  music: Yr,
  "my-payment-cards": jr,
  navigation: qr,
  notification: Kr,
  "number-of-seats": Qr,
  oil: zr,
  "open-letter": Jr,
  padlock: Vr,
  parking: Xr,
  "pay-as-you-go": Zr,
  "pay-by-bank-transfer": _r,
  "payg-drive": $r,
  "payment-schedule": ro,
  "ping-driver": oo,
  placeholder: mo,
  planet: to,
  plug: eo,
  plumbing: io,
  "power-move": po,
  "price-cut": ao,
  price: fo,
  queue: no,
  "real-charge2": so,
  "real-charge": co,
  "scheduled-top-ups": lo,
  seats: go,
  "security-dog": uo,
  "semi-detached": ho,
  "smart-home": yo,
  "smart-meter": bo,
  "smart-thermostat-a": Co,
  "smart-thermostat-b": Po,
  smoke: vo,
  "solar-panel": To,
  "special-effects": So,
  sport: Eo,
  star: ko,
  "store-locator": Bo,
  "strobe-lights2": Mo,
  "strobe-lights": wo,
  sun: xo,
  "taps-and-toilets": Ao,
  terraced: Lo,
  "the-grid": Do,
  "thumbs-down": Uo,
  "thumbs-up": Ho,
  ticket: Io,
  "time-running-out": Fo,
  toilet: Go,
  "top-up-in-paypoint-shop": Wo,
  "top-up-in-store": Oo,
  "top-up-card-or-key": Ro,
  "top-up-online": No,
  "top-up": Yo,
  torch: jo,
  train: qo,
  trees: Ko,
  turbine: Qo,
  "unavailable-charger": zo,
  underground: Jo,
  usage: Vo,
  wallet: Xo,
  "warm-home": Zo,
  "water-supply-pipe": _o,
  "wind-energy": $o,
  "womens-toilet": rm,
  wrench: om
}, r = a(null);
function _e() {
  return m(r) || t;
}
function $e({
  children: o,
  pictograms: e = {}
}) {
  const i = {
    ...m(r) || t,
    ...e
  };
  return /* @__PURE__ */ p(r.Provider, { value: i, children: o });
}
export {
  $e as PictogramsProvider,
  t as defaultPictograms,
  _e as usePictograms
};
